const state = {
  selected: {
    shipmentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
    mawb: ''
  }
};

const mutations = {
  SET_SELECTED (state, payload) {
    state.selected = payload;
  }
}

const actions = {
  ON_SELECTED_CHANGE({ commit }, data) {
    commit("SET_SELECTED", data);
  }
};

const getters = {
  getSelected: state => state.selected
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};



      // // var currentDate = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Bangkok"})).toLocaleString()
      // var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      // var localISOTime = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
